/**
 * Módulo de Listagens
 * Responsável por funcionalidades de listagem, paginação e busca para diferentes entidades
 */

import {
    createSimplePagination,
    setupSearchWithPagination,
} from "../../shared/components/pagination.js";
import "select2";
import "bootstrap-daterangepicker";
import moment from "moment";

/**
 * Inicializa o módulo de listagens
 */
export function initListingsModule() {
    initServicesListing();
    initGaragesListing();
    initEmployeesListing();
    initServiceOrdersListing();
    initSuppliersListing();
}

/**
 * Inicializa listagem de serviços
 */
function initServicesListing() {
    if ($("body").hasClass("services-index")) {
        // Use new pagination component
        const paginationConfig = {
            container: ".tbodyServices",
            loadUrl: window.location.pathname,
            searchInput: "#searchService",
            searchUrl: "/servicos/buscar",
            pageInput: "#currentPage",
        };

        createSimplePagination(paginationConfig);

        // Filtro input busca serviço
        $("#searchService").on("keyup", function () {
            let value = $(this).val();
            $(".textNoData").hide();
            $(".dataNotFound").hide();

            if (value.length >= 3) {
                $("body").addClass("loaded-search");
                getDataServices(value);
            }

            if (value.length == 0) {
                value = "";
                $("body").removeClass("loaded-search");
                getDataServices(value);
            }

            function getDataServices(value) {
                $.ajax({
                    url: "/servicos/search",
                    type: "POST",
                    data: {
                        value: value,
                    },
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        ),
                    },
                    beforeSend: function () {
                        $(".table-services").hide();
                        $(".loadingSearch").show();
                    },
                    success: function (response) {
                        if (response.html !== "") {
                            $(".dataNotFound").hide();
                            setTimeout(function () {
                                $(".table-services").show();
                                $(".tbodyServices").empty();
                                $(".tbodyServices").append(response.html);
                                $(".loadingSearch").hide();
                            }, 2000);
                        } else {
                            $(".loadingSearch").hide();
                            $(".dataNotFound").show();
                        }
                    },
                    error: function (xhr, status, error) {},
                });
            }
        });
    }
}

/**
 * Inicializa listagem de oficinas
 */
function initGaragesListing() {
    if ($("body").hasClass("garage-index")) {
        let page = 2;
        let loading = false;

        $(window).on("scroll", function () {
            if (loading) return;

            if (
                $(window).scrollTop() + $(window).height() >=
                $(document).height() * 1
            ) {
                loadMoreGarages();
            }
        });

        function loadMoreGarages() {
            if (!$("body").hasClass("loaded-search")) {
                loading = true;

                $.ajax({
                    url: `?page=${page}`,
                    type: "GET",
                    beforeSend: function () {
                        $(".loadingPage").show();
                    },
                    success: function (response) {
                        if (response.execute) {
                            if (response.html.trim() !== "") {
                                $(".table-garage").append(response.html);
                            }

                            if (response.nextPage !== null) {
                                page++;
                                $("#currentPage").val(page);
                                loading = false;
                            } else {
                                loading = true;
                                $(".textNoData").show();
                            }
                        } else {
                            loading = true;
                        }
                    },
                    complete: function () {
                        $(".loadingPage").hide();
                    },
                    error: function () {
                        $(".loadingPage").hide();
                        loading = false;
                    },
                });
            }
        }

        // Filtro input busca oficina
        $("#searchGarage").on("keyup", function () {
            let value = $(this).val();
            $(".textNoData").hide();
            $(".dataNotFound").hide();

            if (value.length >= 3) {
                $("body").addClass("loaded-search");
                getDataGarages(value);
            }

            if (value.length == 0) {
                value = "";
                $("body").removeClass("loaded-search");
                getDataGarages(value);
            }

            function getDataGarages(value) {
                $.ajax({
                    url: "/backoffice/garage/search",
                    type: "POST",
                    data: {
                        value: value,
                    },
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        ),
                    },
                    beforeSend: function () {
                        $(".table-services").hide();
                        $(".loadingSearch").show();
                    },
                    success: function (response) {
                        if (response.html !== "") {
                            $(".dataNotFound").hide();
                            setTimeout(function () {
                                $(".table-garage").show();
                                $(".tbodyGarages").empty();
                                $(".tbodyGarages").append(response.html);
                                $(".loadingSearch").hide();
                            }, 2000);
                        } else {
                            $(".loadingSearch").hide();
                            $(".dataNotFound").show();
                        }
                    },
                    error: function (xhr, status, error) {},
                });
            }
        });
    }
}

/**
 * Inicializa listagem de funcionários
 */
function initEmployeesListing() {
    // Moved to employee/index.js to unify search/filter logic
    return;
}

/**
 * Inicializa listagem de ordens de serviço
 */
function initServiceOrdersListing() {
    if ($("body").hasClass("orders-index")) {
        let page = 2;
        let loading = false;
        let activeTab = "all-tab";

        $(window).on("scroll", function () {
            if (loading) return;

            const threshold = 120; // margem antes do fim da página
            const nearBottom =
                $(window).scrollTop() + $(window).height() >=
                $(document).height() - threshold;

            if (nearBottom) {
                // Decide fonte de paginação conforme contexto atual
                const searchVal = ($(".searchServiceOrder").val() || "").trim();
                const inSearch =
                    searchVal.length >= 3 ||
                    $("body").hasClass("loaded-search");
                const filtersOn = $("body").hasClass("filters-applied");

                // Prioriza filtros aplicados; se houver busca, ela será mesclada nos filtros
                if (filtersOn) {
                    loadMoreServiceOrdersFiltered();
                    return;
                }
                if (inSearch) {
                    loadMoreServiceOrdersSearch();
                    return;
                }
                // Padrão: listagem "Todos"
                loadMoreServiceOrders(activeTab);
            }
        });

        // Removido: carregamento por aba via .nav-link, mantendo apenas "Todos"
        $(".nav-link").on("click", function (e) {
            e.preventDefault();
            $("body").removeClass("loaded-search");
            $(".searchServiceOrder").val("");
            let activeTab = $(this).attr("id");
            loadTabStatusServiceOrder(activeTab);
        });

        function loadTabStatusServiceOrder(activeTab) {
            let statusOS = getStatusFromTab(activeTab);
            let page = 1;
            let classFormat =
                statusOS.charAt(0).toUpperCase() + statusOS.slice(1);
            const orderBy = $("#orderBySelect").val() || "id_os";

            $.ajax({
                url: `?page=${page}&status=${statusOS}&loadTab=true&order_by=${orderBy}`,
                type: "GET",
                success: function (response) {
                    $(`.textNoData${classFormat}`).hide();
                    $(`.tbody${classFormat}`).empty();
                    if (response.execute) {
                        $(`.loadingPage${classFormat}`).show();

                        if (response.html.trim() !== "") {
                            setTimeout(function () {
                                $(`.tbody${classFormat}`)
                                    .empty()
                                    .append(response.html);
                            }, 2000);
                        }

                        if (response.nextPage !== null) {
                            page++;
                            $("#currentPage").val(page);
                            loading = false;
                        } else {
                            loading = true;
                            setTimeout(function () {
                                $(`.textNoData${classFormat}`).show();
                                $(`.loadingPage${classFormat}`).hide();
                            }, 2000);
                        }
                    } else {
                        loading = true;
                    }
                },
                complete: function () {
                    setTimeout(function () {
                        $(`.loadingPage${classFormat}`).hide();
                    }, 2000);
                },
            });
        }

        function loadMoreServiceOrders(activeTab) {
            if (!$("body").hasClass("loaded-search")) {
                loading = true;
                let statusOS = getStatusFromTab(activeTab);
                let classFormat =
                    statusOS.charAt(0).toUpperCase() + statusOS.slice(1);
                const orderBy = $("#orderBySelect").val() || "id_os";

                if (page >= 1) {
                    $.ajax({
                        url: `?page=${page}&status=${statusOS}&order_by=${orderBy}`,
                        type: "GET",
                        beforeSend: function () {
                            const $specificLoader = $(
                                `.loadingPage${classFormat}`
                            );
                            if ($specificLoader.length) {
                                $specificLoader.show();
                            } else {
                                $(".loadingPage").show();
                            }
                        },
                        success: function (response) {
                            if (response.execute) {
                                // loader já exibido em beforeSend

                                if (response.html.trim() !== "") {
                                    setTimeout(function () {
                                        $(`.tbody${classFormat}`).append(
                                            response.html
                                        );
                                    }, 2000);
                                }

                                if (response.nextPage !== null) {
                                    // Atualiza corretamente a variável de página para evitar repetição
                                    page = response.nextPage;
                                    $("#currentPage").val(page);
                                    loading = false;
                                } else {
                                    // Não há próxima página: bloqueia novas requisições
                                    page = -1;
                                    loading = true;
                                    setTimeout(function () {
                                        $(`.textNoData${classFormat}`).show();
                                        const $specificLoader = $(
                                            `.loadingPage${classFormat}`
                                        );
                                        if ($specificLoader.length) {
                                            $specificLoader.hide();
                                        } else {
                                            $(".loadingPage").hide();
                                        }
                                    }, 2000);
                                }
                            } else {
                                loading = true;
                            }
                        },
                        complete: function () {
                            setTimeout(function () {
                                const $specificLoader = $(
                                    `.loadingPage${classFormat}`
                                );
                                if ($specificLoader.length) {
                                    $specificLoader.hide();
                                } else {
                                    $(".loadingPage").hide();
                                }
                            }, 2000);
                        },
                    });
                }
            }
        }

        // Filtro input busca ordem de serviço (delegado para inputs dinâmicos)
        let metricsSearchTimer;
        $(document).off("keyup.searchSO");
        $(document).on("keyup.searchSO", ".searchServiceOrder", function () {
            let value = $(this).val();
            let status = $(this).data("status");
            let classe = getClassFromStatus(status);

            $(`.textNoData${classe}`).hide();
            $(`.dataNotFound${classe}`).hide();

            if (value.length >= 3) {
                $("body").addClass("loaded-search");
                getDataServiceOrders(value, status, classe);
                // Atualiza BigNumbers imediatamente com debounce leve
                clearTimeout(metricsSearchTimer);
                metricsSearchTimer = setTimeout(function () {
                    try {
                        const merged = Object.assign(
                            {},
                            window.__currentFilters || {},
                            { status: status, value: value, search: value }
                        );
                        fetchAndRenderMetrics(merged);
                    } catch (e) {
                        console.warn("Falha ao disparar métricas:", e);
                    }
                }, 150);
            }

            if (value.length == 0) {
                value = "";
                $("body").removeClass("loaded-search");
                getDataServiceOrders(value, status, classe);
                // Atualiza BigNumbers ao limpar a busca
                clearTimeout(metricsSearchTimer);
                metricsSearchTimer = setTimeout(function () {
                    try {
                        const merged = Object.assign(
                            {},
                            window.__currentFilters || {},
                            { status: status, value: value, search: value }
                        );
                        fetchAndRenderMetrics(merged);
                    } catch (e) {
                        console.warn("Falha ao disparar métricas:", e);
                    }
                }, 150);
            }
        });

        function getDataServiceOrders(value, status, classe) {
            // Reset de paginação ao iniciar nova busca
            page = 1;
            const orderBy = $("#orderBySelect").val() || "id_os";
            $.ajax({
                url: "/OS/search",
                type: "POST",
                data: Object.assign({}, window.__currentFilters || {}, {
                    value: value,
                    status: status,
                    order_by: orderBy,
                    page: 1,
                }),
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                beforeSend: function () {
                    $(`.tbody${classe}`).hide();
                    $(`.loadingSearch${classe}`).show();
                },
                success: function (response) {
                    if (response && response.execute && response.html !== "") {
                        $(`.dataNotFound${classe}`).hide();
                        // Renderiza lista imediatamente
                        $(`.tbody${classe}`).empty();
                        $(`.tbody${classe}`).append(response.html);
                        $(`.loadingSearch${classe}`).hide();
                        $(`.tbody${classe}`).show();
                        // Atualiza paginação corrente da busca
                        if (response.nextPage !== null) {
                            $("#currentPage").val(response.nextPage);
                            page = response.nextPage;
                        } else {
                            $("#currentPage").val(-1);
                            page = -1;
                        }
                        // Atualiza BigNumbers conforme modo de busca sem atraso
                        try {
                            const merged = Object.assign(
                                {},
                                window.__currentFilters || {},
                                { status: status, value: value, search: value }
                            );
                            fetchAndRenderMetrics(merged);
                        } catch (e) {
                            console.warn(
                                "Falha ao atualizar métricas na busca:",
                                e
                            );
                        }
                    } else {
                        $(`.loadingSearch${classe}`).hide();
                        $(`.dataNotFound${classe}`).show();
                        // Mesmo sem resultados, atualizar métricas para refletir busca
                        try {
                            const merged = Object.assign(
                                {},
                                window.__currentFilters || {},
                                { status: status, value: value, search: value }
                            );
                            fetchAndRenderMetrics(merged);
                        } catch (e) {
                            console.warn(
                                "Falha ao atualizar métricas (sem resultados):",
                                e
                            );
                        }
                    }
                },
                error: function (xhr, status, error) {},
            });
        }

        // Carregar mais resultados em modo de busca (scroll)
        function loadMoreServiceOrdersSearch() {
            const status = $(".searchServiceOrder").data("status") || "todos";
            const value = $(".searchServiceOrder").val() || "";
            const classe = getClassFromStatus(status);
            const orderBy = $("#orderBySelect").val() || "id_os";
            const applied = window.__currentFilters || {};

            if (page >= 1) {
                loading = true;
                $.ajax({
                    url: "/OS/search",
                    type: "POST",
                    data: Object.assign({}, applied, {
                        value,
                        status,
                        order_by: orderBy,
                        page,
                    }),
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        ),
                    },
                    beforeSend: function () {
                        // Esconde estados de vazio e mostra loader mais adequado
                        $(`.textNoData${classe}`).hide();
                        $(`.dataNotFound${classe}`).hide();
                        const $bottomSpec = $(`.loadingPage${classe}`);
                        const $searchSpec = $(`.loadingSearch${classe}`);
                        if ($bottomSpec.length) {
                            $bottomSpec.show();
                        } else if ($searchSpec.length) {
                            $searchSpec.show();
                        } else {
                            $(".loadingPage").show();
                        }
                    },
                    success: function (resp) {
                        if (
                            resp &&
                            resp.execute &&
                            resp.html &&
                            resp.html.trim() !== ""
                        ) {
                            setTimeout(function () {
                                $(`.tbody${classe}`).append(resp.html);
                            }, 200);
                        }
                        if (resp && resp.nextPage !== null) {
                            page = resp.nextPage;
                            $("#currentPage").val(page);
                            loading = false;
                        } else {
                            page = -1;
                            loading = true;
                            setTimeout(function () {
                                $(`.textNoData${classe}`).show();
                                const $bottomSpec = $(`.loadingPage${classe}`);
                                const $searchSpec = $(
                                    `.loadingSearch${classe}`
                                );
                                if ($bottomSpec.length) {
                                    $bottomSpec.hide();
                                }
                                if ($searchSpec.length) {
                                    $searchSpec.hide();
                                }
                                if (
                                    !$bottomSpec.length &&
                                    !$searchSpec.length
                                ) {
                                    $(".loadingPage").hide();
                                }
                            }, 200);
                        }
                    },
                    complete: function () {
                        const $bottomSpec = $(`.loadingPage${classe}`);
                        const $searchSpec = $(`.loadingSearch${classe}`);
                        if ($bottomSpec.length) {
                            $bottomSpec.hide();
                        }
                        if ($searchSpec.length) {
                            $searchSpec.hide();
                        }
                        if (!$bottomSpec.length && !$searchSpec.length) {
                            $(".loadingPage").hide();
                        }
                    },
                });
            }
        }
        // Carregar mais resultados com filtros aplicados (scroll)
        function loadMoreServiceOrdersFiltered() {
            const orderBy = $("#orderBySelect").val() || "id_os";
            const csrf = $('meta[name="csrf-token"]').attr("content");
            const applied = window.__currentFilters || {};
            const searchVal = ($(".searchServiceOrder").val() || "").trim();
            const data = { ...applied, order_by: orderBy, page };
            if (searchVal.length >= 3) {
                data.value = searchVal; // mescla termo de busca aos filtros
            }
            // Em layout atual, manipule sempre elementos da listagem "Todos"
            const classe = "All";

            if (page >= 1) {
                loading = true;
                $.ajax({
                    url: "/OS/filter",
                    method: "POST",
                    data,
                    headers: { "X-CSRF-TOKEN": csrf },
                    beforeSend: function () {
                        $(`.textNoData${classe}`).hide();
                        $(`.dataNotFound${classe}`).hide();
                        const $spec = $(`.loadingPage${classe}`);
                        if ($spec.length) {
                            $spec.show();
                        } else {
                            $(".loadingPage").show();
                        }
                    },
                    success: function (resp) {
                        if (
                            resp &&
                            resp.execute &&
                            resp.html &&
                            resp.html.trim() !== ""
                        ) {
                            setTimeout(function () {
                                $(`.tbody${classe}`).append(resp.html);
                            }, 200);
                        }
                        if (resp && resp.nextPage !== null) {
                            page = resp.nextPage;
                            $("#currentPage").val(page);
                            loading = false;
                        } else {
                            page = -1;
                            loading = true;
                            setTimeout(function () {
                                $(`.textNoData${classe}`).show();
                                const $spec = $(`.loadingPage${classe}`);
                                if ($spec.length) {
                                    $spec.hide();
                                } else {
                                    $(".loadingPage").hide();
                                }
                            }, 200);
                        }
                    },
                    complete: function () {
                        const $spec = $(`.loadingPage${classe}`);
                        if ($spec.length) {
                            $spec.hide();
                        } else {
                            $(".loadingPage").hide();
                        }
                    },
                });
            }
        }
    }
}

/**
 * Inicializa listagem de fornecedores
 */
function initSuppliersListing() {
    // Moved to suppliers/index.js to unify search/filter logic
    return;
}

/**
 * Converte tab ID para status
 * @param {string} tabId - ID da tab
 * @returns {string} Status correspondente
 */
function getStatusFromTab(tabId) {
    const statusMap = {
        "all-tab": "all",
        "late-tab": "late",
        "open-tab": "open",
        "waitingApproval-tab": "waitingApproval",
        "draft-tab": "draft",
        "canceled-tab": "canceled",
        "done-tab": "done",
    };

    return statusMap[tabId] || "all";
}

/**
 * Converte status para classe CSS
 * @param {string} status - Status da OS
 * @returns {string} Classe CSS correspondente
 */
function getClassFromStatus(status) {
    const classMap = {
        todos: "All",
        atrasado: "Late",
        "em aberto": "Open",
        "em aprovacao": "WaitingApproval",
        rascunho: "Draft",
        concluido: "Done",
        cancelado: "Canceled",
    };

    return classMap[status] || "All";
}

// Filtros: drawer e submissão (Service Orders)
if ($("body").hasClass("orders-index") && !$("body").hasClass("empty-orders")) {
    const $drawer = $("#filtersDrawer");
    const $backdrop = $("#filtersDrawerBackdrop");
    const $form = $("#serviceOrdersFiltersForm");
    const $filtersBadge = $("#filtersCountBadge");

    // Estado persistente dos filtros aplicados
    let filtersApplied = false;
    let filtersOptionsLoaded = false;
    let currentFilters = {
        status: "todos",
        emissao_de: "",
        emissao_ate: "",
        conclusao_de: "",
        conclusao_ate: "",
        status_os: "",
        status_pagamento: "",
        responsavel: "",
        cliente: [],
        veiculo: [],
    };

    function countAppliedFilters() {
        const cf = currentFilters || {};
        let count = 0;
        // Emissão (um ou ambos os campos contam como 1 filtro)
        if (
            (cf.emissao_de && cf.emissao_de !== "") ||
            (cf.emissao_ate && cf.emissao_ate !== "")
        )
            count++;
        // Conclusão (um ou ambos os campos contam como 1 filtro)
        if (
            (cf.conclusao_de && cf.conclusao_de !== "") ||
            (cf.conclusao_ate && cf.conclusao_ate !== "")
        )
            count++;
        // Status da O.S. (ignora "todos")
        if (cf.status_os && cf.status_os !== "" && cf.status_os !== "todos")
            count++;
        // Status pagamento
        if (cf.status_pagamento && cf.status_pagamento !== "") count++;
        // Responsável
        if (cf.responsavel && cf.responsavel !== "") count++;
        // Cliente(s)
        if (Array.isArray(cf.cliente) && cf.cliente.length > 0) count++;
        // Veículo(s)
        if (Array.isArray(cf.veiculo) && cf.veiculo.length > 0) count++;
        return count;
    }

    function updateFiltersBadge() {
        const count = countAppliedFilters();
        if ($filtersBadge && $filtersBadge.length) {
            if (count > 0) {
                $filtersBadge.text(count).removeClass("d-none");
            } else {
                $filtersBadge.addClass("d-none").text("");
            }
        }
    }

    // Inicializa badge oculto/valor correto ao carregar
    updateFiltersBadge();

    // Busca inicial das métricas BigNumbers com filtros padrão
    fetchAndRenderMetrics(currentFilters);

    function mapTabStatus(statusAttr) {
        // Normaliza status para os valores usados no backend
        const map = {
            todos: "todos",
            late: "atrasado",
            "em aberto": "em aberto",
            "em aprovacao": "em aprovacao",
            rascunho: "rascunho",
            concluido: "concluido",
            cancelado: "cancelado",
        };
        return map[statusAttr] || "todos";
    }

    function initSelect2Filters() {
        const commonOpts = {
            width: "100%",
            allowClear: true,
        };
        const $cliente = $("#clienteSelect");
        const $veiculo = $("#veiculoSelect");
        if ($cliente.hasClass("select2-hidden-accessible")) {
            $cliente.select2("destroy");
        }
        if ($veiculo.hasClass("select2-hidden-accessible")) {
            $veiculo.select2("destroy");
        }
        $cliente.next(".select2-container").remove();
        $veiculo.next(".select2-container").remove();
        $cliente.select2({ ...commonOpts, placeholder: "Selecione clientes" });
        $veiculo.select2({ ...commonOpts, placeholder: "Selecione veículos" });
    }

    function openDrawer(statusAttr) {
        const normalized = mapTabStatus(statusAttr);
        // Se já aplicou filtros antes, mantenha o status anterior; caso contrário, use o do botão
        const statusToUse = filtersApplied
            ? currentFilters.status || "todos"
            : normalized;
        $("#filtersStatus").val(statusToUse);

        // Aplicar valores salvos aos campos simples antes de abrir
        $("#emissaoDe").val(currentFilters.emissao_de || "");
        $("#emissaoAte").val(currentFilters.emissao_ate || "");
        $("#conclusaoDe").val(currentFilters.conclusao_de || "");
        $("#conclusaoAte").val(currentFilters.conclusao_ate || "");
        $("#statusOS").val(currentFilters.status_os || "");
        $("#statusPagamento").val(currentFilters.status_pagamento || "");

        // Inicializar Date Range Picker se ainda não estiver
        initDateRangePickers();

        // Restaurar valores visuais dos ranges se existirem nos filtros
        if (currentFilters.emissao_de && currentFilters.emissao_ate) {
            const start = moment(currentFilters.emissao_de);
            const end = moment(currentFilters.emissao_ate);
            $("#emissaoRange").data("daterangepicker").setStartDate(start);
            $("#emissaoRange").data("daterangepicker").setEndDate(end);
            $("#emissaoRange").val(
                start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY")
            );
        } else {
            $("#emissaoRange").val("");
        }

        if (currentFilters.conclusao_de && currentFilters.conclusao_ate) {
            const start = moment(currentFilters.conclusao_de);
            const end = moment(currentFilters.conclusao_ate);
            $("#conclusaoRange").data("daterangepicker").setStartDate(start);
            $("#conclusaoRange").data("daterangepicker").setEndDate(end);
            $("#conclusaoRange").val(
                start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY")
            );
        } else {
            $("#conclusaoRange").val("");
        }

        $drawer.addClass("open");
        $backdrop.addClass("show");
        // Carrega opções de filtro apenas uma vez para evitar sobrescrever seleções do usuário
        loadFilterOptions();
    }

    function closeDrawer() {
        $drawer.removeClass("open");
        $backdrop.removeClass("show");
    }

    function resetAllFilters() {
        $form[0]?.reset();
        $("#responsavelSelect").val("").trigger("change");
        $("#clienteSelect").val(null).trigger("change");
        $("#veiculoSelect").val(null).trigger("change");

        // Resetar estado persistente
        filtersApplied = false;
        currentFilters = {
            status: "todos",
            emissao_de: "",
            emissao_ate: "",
            conclusao_de: "",
            conclusao_ate: "",
            status_os: "",
            status_pagamento: "",
            responsavel: "",
            cliente: [],
            veiculo: [],
        };

        // Atualiza badge
        updateFiltersBadge();
    }

    function loadFilterOptions() {
        // Evita recarregar e resetar selects enquanto usuário interage
        if (filtersOptionsLoaded) return;
        filtersOptionsLoaded = true;

        const csrf = $('meta[name="csrf-token"]').attr("content");

        // Responsáveis
        $.ajax({
            url: "/funcionarios/getEmployees",
            method: "POST",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": csrf },
            success: function (resp) {
                const $select = $("#responsavelSelect");
                // Preserva seleção atual caso já exista
                const prevVal = $select.val();
                $select.empty().append('<option value="">Selecione</option>');
                (resp.employees || []).forEach((e) => {
                    $select.append(
                        `<option value="${e.id}">${e.text}</option>`
                    );
                });
                // Aplicar seleção persistente ou manter a anterior
                const toApply =
                    filtersApplied && currentFilters.responsavel
                        ? currentFilters.responsavel
                        : prevVal;
                if (toApply) $select.val(toApply).trigger("change");
            },
            error: function (xhr) {
                console.error(
                    "Erro ao carregar responsáveis:",
                    xhr?.status,
                    xhr?.responseText
                );
            },
        });

        // Clientes (lista completa)
        $.ajax({
            url: "/clientes/getClients",
            method: "POST",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": csrf },
            success: function (resp) {
                const clients = resp.clients || [];
                const $cliente = $("#clienteSelect");
                // Preserva seleção atual
                const prevClients = $cliente.val();
                // Inicializa Select2 com dados
                $cliente.empty();
                $cliente.select2({
                    width: "100%",
                    allowClear: true,
                    placeholder: "Selecione",
                    data: clients,
                });
                // Aplicar seleção persistente ou manter a anterior
                const toApplyClients =
                    filtersApplied &&
                    Array.isArray(currentFilters.cliente) &&
                    currentFilters.cliente.length
                        ? currentFilters.cliente
                        : prevClients;
                if (toApplyClients && toApplyClients.length) {
                    $cliente.val(toApplyClients).trigger("change");
                }
            },
            error: function (xhr) {
                console.error(
                    "Erro ao carregar clientes:",
                    xhr?.status,
                    xhr?.responseText
                );
            },
        });

        // Veículos (lista completa, independente de cliente)
        $.ajax({
            url: "/veiculos/getVehicles",
            method: "POST",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": csrf },
            data: {
                value: "",
                cliente: "",
            },
            success: function (resp) {
                const vehicles = resp.results || [];
                const $veiculo = $("#veiculoSelect");
                // Preserva seleção atual
                const prevVehicles = $veiculo.val();
                // Inicializa Select2 com dados
                $veiculo.empty();
                $veiculo.select2({
                    width: "100%",
                    allowClear: true,
                    placeholder: "Selecione",
                    data: vehicles,
                });
                // Aplicar seleção persistente ou manter a anterior
                const toApplyVehicles =
                    filtersApplied &&
                    Array.isArray(currentFilters.veiculo) &&
                    currentFilters.veiculo.length
                        ? currentFilters.veiculo
                        : prevVehicles;
                if (toApplyVehicles && toApplyVehicles.length) {
                    $veiculo.val(toApplyVehicles).trigger("change");
                }
            },
            error: function (xhr) {
                console.error(
                    "Erro ao carregar veículos:",
                    xhr?.status,
                    xhr?.responseText
                );
            },
        });
    }

    function initDateRangePickers() {
        if ($("#emissaoRange").data("daterangepicker")) return;

        const ranges = {
            Hoje: [moment(), moment()],
            "Últimos 7 Dias": [moment().subtract(6, "days"), moment()],
            "Últimos 30 Dias": [moment().subtract(29, "days"), moment()],
            "Este Mês": [moment().startOf("month"), moment().endOf("month")],
            "Mês Anterior": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
            ],
        };

        const locale = {
            format: "DD/MM/YYYY",
            separator: " - ",
            applyLabel: "Aplicar",
            cancelLabel: "Cancelar",
            fromLabel: "De",
            toLabel: "Até",
            customRangeLabel: "Personalizado",
            weekLabel: "S",
            daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            monthNames: [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro",
            ],
            firstDay: 1,
        };

        const config = {
            autoUpdateInput: false,
            locale: locale,
            ranges: ranges,
            opens: "left",
            alwaysShowCalendars: true,
        };

        // Emissão
        $("#emissaoRange").daterangepicker(config);
        $("#emissaoRange").on("apply.daterangepicker", function (ev, picker) {
            $(this).val(
                picker.startDate.format("DD/MM/YYYY") +
                    " - " +
                    picker.endDate.format("DD/MM/YYYY")
            );
            $("#emissaoDe").val(picker.startDate.format("YYYY-MM-DD"));
            $("#emissaoAte").val(picker.endDate.format("YYYY-MM-DD"));
        });
        $("#emissaoRange").on("cancel.daterangepicker", function (ev, picker) {
            $(this).val("");
            $("#emissaoDe").val("");
            $("#emissaoAte").val("");
        });

        // Conclusão
        $("#conclusaoRange").daterangepicker(config);
        $("#conclusaoRange").on("apply.daterangepicker", function (ev, picker) {
            $(this).val(
                picker.startDate.format("DD/MM/YYYY") +
                    " - " +
                    picker.endDate.format("DD/MM/YYYY")
            );
            $("#conclusaoDe").val(picker.startDate.format("YYYY-MM-DD"));
            $("#conclusaoAte").val(picker.endDate.format("YYYY-MM-DD"));
        });
        $("#conclusaoRange").on(
            "cancel.daterangepicker",
            function (ev, picker) {
                $(this).val("");
                $("#conclusaoDe").val("");
                $("#conclusaoAte").val("");
            }
        );
    }

    // Removido carregamento de veículos por cliente — lista é global
    $("#clienteSelect").off("change");

    // Botões abrir/fechar
    $(document).on("click", ".btn-open-filters", function () {
        const statusAttr = $(this).data("status");
        openDrawer(statusAttr);
    });

    $(document).on("click", ".btn-close-filters", function () {
        closeDrawer();
    });
    $(document).on("click", "#filtersDrawerBackdrop", function () {
        closeDrawer();
    });

    // Limpar campo individual
    $(document).on("click", ".clear-field", function () {
        const target = $(this).data("target");
        if (target === "emissao") {
            $("#emissaoDe, #emissaoAte").val("");
            $("#emissaoRange").val("");
        } else if (target === "conclusao") {
            $("#conclusaoDe, #conclusaoAte").val("");
            $("#conclusaoRange").val("");
        }
    });

    // Limpar selects individuais
    $(document).on("click", ".clear-select", function () {
        const target = $(this).data("target");
        if (target === "status_os") $("#statusOS").val("");
        if (target === "status_pagamento") $("#statusPagamento").val("");
        if (target === "responsavel") $("#responsavelSelect").val("");
        if (target === "cliente")
            $("#clienteSelect").val(null).trigger("change");
        if (target === "veiculo")
            $("#veiculoSelect").val(null).trigger("change");
    });

    // Limpar tudo
    $(document).on("click", "#btnClearAllFilters", function () {
        resetAllFilters();
        $("body").removeClass("filters-applied");
        // Auto-apply after clearing
        $("#btnApplyFilters").trigger("click");
    });

    // Aplicar filtros
    $(document).on("click", "#btnApplyFilters", function () {
        const orderBy = $("#orderBySelect").val() || "id_os";
        const searchVal = ($(".searchServiceOrder").val() || "").trim();
        const data = {
            status: $("#filtersStatus").val() || "todos",
            emissao_de: $("#emissaoDe").val(),
            emissao_ate: $("#emissaoAte").val(),
            conclusao_de: $("#conclusaoDe").val(),
            conclusao_ate: $("#conclusaoAte").val(),
            status_os: $("#statusOS").val(),
            status_pagamento: $("#statusPagamento").val(),
            responsavel: $("#responsavelSelect").val(),
            cliente: $("#clienteSelect").val(), // múltiplos IDs se selecionado
            veiculo: $("#veiculoSelect").val(), // múltiplos IDs se selecionado
            order_by: orderBy,
            search: searchVal,
            page: 1,
        };

        // Em layout atual, existe apenas a listagem "Todos" (tbodyAll, loaders All)
        // Portanto, direcionamos sempre para as classes "All" para garantir que
        // loaders, mensagens e tbody corretos sejam manipulados.
        const classe = "All";
        const csrf = $('meta[name="csrf-token"]').attr("content");

        $.ajax({
            url: "/OS/filter",
            method: "POST",
            data: data,
            headers: { "X-CSRF-TOKEN": csrf },
            beforeSend: function () {
                $(`.tbody${classe}`).hide();
                $(`.loadingSearch${classe}`).show();
            },
            success: function (resp) {
                if (resp && resp.execute && resp.html) {
                    $(`.dataNotFound${classe}`).hide();
                    $(`.tbody${classe}`).empty().append(resp.html).show();
                    // Atualiza barra de seleção quando a tabela é substituída
                    updateSelectedCount();
                    // Atualiza métricas BigNumbers conforme filtros aplicados
                    fetchAndRenderMetrics(data);
                    // Estado de paginação e contexto de filtros
                    if (resp.nextPage !== null) {
                        $("#currentPage").val(resp.nextPage);
                    } else {
                        $("#currentPage").val(-1);
                    }
                    $("body").addClass("filters-applied");
                    window.__currentFilters = { ...data };
                } else {
                    $(`.dataNotFound${classe}`).show();
                }
            },
            complete: function () {
                $(`.loadingSearch${classe}`).hide();
            },
            error: function () {
                $(`.loadingSearch${classe}`).hide();
            },
        });

        // Salvar estado aplicado para persistir na próxima abertura
        filtersApplied = true;
        currentFilters = { ...data };
        window.__currentFilters = { ...data };

        // Atualiza badge com o estado recém-aplicado
        updateFiltersBadge();

        closeDrawer();
    });

    // Alteração de ordenação: reaplica listagem conforme contexto (busca, filtros, ou padrão)
    $(document).on("change", "#orderBySelect", function () {
        const orderBy = $(this).val() || "id_os";
        const csrf = $('meta[name="csrf-token"]').attr("content");
        const searchVal = $(".searchServiceOrder").val() || "";

        // Se está em modo de busca
        if ($("body").hasClass("loaded-search")) {
            const status = $(".searchServiceOrder").data("status") || "todos";
            const classe = getClassFromStatus(status);
            $.ajax({
                url: "/OS/search",
                method: "POST",
                data: Object.assign({}, window.__currentFilters || {}, {
                    value: searchVal,
                    status,
                    order_by: orderBy,
                    page: 1,
                }),
                headers: { "X-CSRF-TOKEN": csrf },
                beforeSend: function () {
                    $(`.tbody${classe}`).hide();
                    $(`.loadingSearch${classe}`).show();
                },
                success: function (resp) {
                    if (resp && resp.execute && resp.html) {
                        $(`.dataNotFound${classe}`).hide();
                        $(`.tbody${classe}`).empty().append(resp.html).show();
                        updateSelectedCount();
                        // Atualiza métricas BigNumbers conforme filtros aplicados
                        const merged = Object.assign(
                            {},
                            window.__currentFilters || {},
                            { status, value: searchVal, search: searchVal }
                        );
                        fetchAndRenderMetrics(merged);
                        if (resp.nextPage !== null) {
                            $("#currentPage").val(resp.nextPage);
                            page = resp.nextPage;
                        } else {
                            $("#currentPage").val(-1);
                            page = -1;
                        }
                    } else {
                        $(`.dataNotFound${classe}`).show();
                    }
                },
                complete: function () {
                    $(`.loadingSearch${classe}`).hide();
                },
            });
            return;
        }

        // Se há filtros aplicados, reaplica com novo order_by
        if (filtersApplied) {
            const data = { ...currentFilters, order_by: orderBy };
            const classe = getClassFromStatus(data.status || "todos");
            $.ajax({
                url: "/OS/filter",
                method: "POST",
                data: { ...data, page: 1 },
                headers: { "X-CSRF-TOKEN": csrf },
                beforeSend: function () {
                    $(`.tbody${classe}`).hide();
                    $(`.loadingSearch${classe}`).show();
                },
                success: function (resp) {
                    if (resp && resp.execute && resp.html) {
                        $(`.dataNotFound${classe}`).hide();
                        $(`.tbody${classe}`).empty().append(resp.html).show();
                        updateSelectedCount();
                        if (resp.nextPage !== null) {
                            $("#currentPage").val(resp.nextPage);
                            page = resp.nextPage;
                        } else {
                            $("#currentPage").val(-1);
                            page = -1;
                        }
                        $("body").addClass("filters-applied");
                        window.__currentFilters = { ...data };
                    } else {
                        $(`.dataNotFound${classe}`).show();
                    }
                },
                complete: function () {
                    $(`.loadingSearch${classe}`).hide();
                },
            });
            currentFilters = { ...data };
            return;
        }

        // Caso padrão: recarrega primeira página da listagem com novo order_by
        const statusOS = "all";
        const page = 1;
        const classFormat = "All";
        $.ajax({
            url: `?page=${page}&status=${statusOS}&loadTab=true&order_by=${orderBy}`,
            type: "GET",
            success: function (response) {
                $(`.textNoData${classFormat}`).hide();
                $(`.tbody${classFormat}`).empty();
                if (response.execute) {
                    $(`.loadingPage${classFormat}`).show();
                    if (response.html && response.html.trim() !== "") {
                        $(`.tbody${classFormat}`).empty().append(response.html);
                        // Atualiza barra de seleção após render da tabela
                        updateSelectedCount();
                        // Atualiza métricas BigNumbers para listagem padrão
                        fetchAndRenderMetrics(currentFilters);
                    }
                    if (response.nextPage !== null) {
                        $("#currentPage").val(response.page + 1);
                    } else {
                        $("#currentPage").val(-1);
                    }
                }
            },
            complete: function () {
                $(`.loadingPage${classFormat}`).hide();
            },
        });
    });
}

// Formata valores monetários em BRL
function formatCurrencyBR(value) {
    try {
        const num = Number(value) || 0;
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
        }).format(num);
    } catch (e) {
        return `R$ ${(Number(value) || 0).toFixed(2).replace(".", ",")}`;
    }
}

// Busca e renderiza métricas agregadas (BigNumbers) de acordo com os filtros
function fetchAndRenderMetrics(filters) {
    const csrf = $('meta[name="csrf-token"]').attr("content");
    const $container = $("#bigNumbers");
    // Mostrar loader visual nas métricas enquanto carrega
    if ($container.length) {
        if (!$container.find(".metrics-loading").length) {
            $container.prepend(
                '<div class="spinner-main text-center metrics-loading" style="display:none;"><i class="sg sg-spinner-gap body-text-xlarge animate-spin"></i></div>'
            );
        }
        $container.addClass("is-loading");
        $container.find(".metrics-loading").show();
    }
    $.ajax({
        url: "/OS/metrics",
        method: "POST",
        data: Object.assign({}, filters || {}, {
            // Assegura compatibilidade de parâmetro para backend
            search:
                filters && filters.value
                    ? filters.value
                    : filters && filters.search
                    ? filters.search
                    : "",
        }),
        headers: { "X-CSRF-TOKEN": csrf },
        success: function (resp) {
            if (!resp) return;
            // Atualiza elementos BigNumbers
            const setText = (selector, text) => {
                const $el = $(selector);
                if ($el.length) $el.text(text);
            };
            setText(
                "#metricRevenueTotal",
                formatCurrencyBR(resp.revenue_total ?? 0)
            );
            setText(
                "#metricProfitTotal",
                formatCurrencyBR(resp.profit_total ?? 0)
            );
            setText(
                "#metricTotalListed",
                ((resp.total_listed ?? 0) || 0).toLocaleString("pt-BR")
            );
            setText(
                "#metricRevenueProducts",
                formatCurrencyBR(resp.revenue_products ?? 0)
            );
            setText(
                "#metricRevenueServices",
                formatCurrencyBR(resp.revenue_services ?? 0)
            );
            setText(
                "#metricProfitProducts",
                formatCurrencyBR(resp.profit_products ?? 0)
            );
            setText(
                "#metricProfitServices",
                formatCurrencyBR(resp.profit_services ?? 0)
            );
        },
        error: function (xhr) {
            console.error(
                "Erro ao carregar métricas de OS:",
                xhr?.status,
                xhr?.responseText
            );
        },
        complete: function () {
            if ($container.length) {
                $container.removeClass("is-loading");
                $container.find(".metrics-loading").hide();
            }
        },
    });
}

// Atualiza a barra de seleção com a contagem atual de itens selecionados
function updateSelectedCount() {
    // Contabiliza seleção na tabela principal; se não houver, usa fallback global
    let count = $(".table-all-tab .tbodyAll .order-select:checked").length;
    if (count === 0) {
        const globalCount = $(".order-select:checked").length;
        if (globalCount > 0) count = globalCount;
    }

    const $toolbar = $("#selectionToolbar");
    const $countEl = $("#selectedCount");

    if ($countEl && $countEl.length) {
        $countEl.text(count);
        const $labelEl = $("#selectedLabel");
        if ($labelEl.length) {
            $labelEl.text(count > 1 ? "itens" : "item");
        }
    }

    if ($toolbar && $toolbar.length) {
        if (count > 0) {
            $toolbar.removeClass("d-none");
        } else {
            $toolbar.addClass("d-none");
        }
    }
}

// Selecionar todos na listagem atual
$(document).on("change", "#selectAllVisible", function () {
    const checked = $(this).is(":checked");
    $(".table-all-tab .tbodyAll .order-select").prop("checked", checked);
    updateSelectedCount();
});

// Atualiza estado do checkbox mestre quando itens são alternados
$(document).on("change", ".order-select", function () {
    const $items = $(".table-all-tab .tbodyAll .order-select");
    const allChecked =
        $items.length > 0 && $items.filter(":checked").length === $items.length;
    $("#selectAllVisible").prop("checked", allChecked);
    updateSelectedCount();
});

// Limpar seleção: desmarca todos os checkboxes e atualiza barra
$(document).off("click.selectionToolbar", "#clearSelectionLink");
$(document).on("click.selectionToolbar", "#clearSelectionLink", function (e) {
    e.preventDefault();
    $(".table-all-tab .tbodyAll .order-select:checked").prop("checked", false);
    $("#selectAllVisible").prop("checked", false);
    updateSelectedCount();
});



// Exportar PDFs individuais das OS selecionadas com progresso (SSE) e download ZIP
// Evita dupla ligação removendo qualquer handler anterior com namespace
$(document).off("click.exportSelected", "#exportSelectedPdf");
$(document).on("click.exportSelected", "#exportSelectedPdf", function (e) {
    e.preventDefault();
    const ids = $(".table-all-tab .tbodyAll .order-select:checked")
        .map(function () {
            return $(this).data("id");
        })
        .get();

    if (ids.length === 0) {
        const message = "Selecione pelo menos uma ordem de serviço.";

        if (typeof window.showSelectionRequired === "function") {
            window.showSelectionRequired(message);
        } else if (
            window.ServiceOrdersIndex &&
            typeof window.ServiceOrdersIndex.showSelectionRequired ===
                "function"
        ) {
            window.ServiceOrdersIndex.showSelectionRequired(message);
        } else {
            // Prioriza o modal padrão de erro com ícone (Bootstrap)
            if (
                window.bootstrap &&
                typeof window.bootstrap.Modal !== "undefined"
            ) {
                let modalEl = document.getElementById("errorModal");
                if (!modalEl) {
                    modalEl = document.createElement("div");
                    modalEl.id = "errorModal";
                    modalEl.className = "modal fade";
                    modalEl.setAttribute("tabindex", "-1");
                    modalEl.setAttribute("aria-modal", "true");
                    modalEl.setAttribute("role", "dialog");
                    modalEl.innerHTML = `
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-body text-center">
                                    <span class="icon-bg-lg m-auto mb-3"><i class="sg sg-smiley-x-eyes"></i></span>
                                    <div id="errorModalMessages" class="mb-3"></div>
                                    <div class="text-center d-flex justify-content-center">
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                    document.body.appendChild(modalEl);
                }

                const messagesEl = modalEl.querySelector("#errorModalMessages");
                if (messagesEl) {
                    messagesEl.innerHTML = `<p class="mb-0">${message}</p>`;
                }

                const modal = new window.bootstrap.Modal(modalEl, {
                    backdrop: "static",
                    keyboard: false,
                });
                modal.show();
                return;
            }

            // Fallback
            alert(message);
        }
        return;
    }

    const $message = $("#exportProgressMessage");
    const $bar = $("#exportProgressBar");
    const modalEl = document.getElementById("exportProgressModal");
    const modal = new bootstrap.Modal(modalEl, {
        backdrop: "static",
        keyboard: false,
    });
    $message.text("Preparando exportação...");
    $bar.css("width", "0%").text("0%");
    modal.show();

    const url = `/OS/export/pdf-zip/progress?ids=${encodeURIComponent(
        ids.join(",")
    )}`;
    const es = new EventSource(url);

    // Watchdog e heartbeat para evitar travamentos por SSE sem eventos
    let lastEventAt = Date.now();
    const perOsMs = 20000; // 20s por OS como limite razoável
    const maxMs = Math.max(60000, ids.length * perOsMs);
    const heartbeatMs = 10000; // esperamos algum evento a cada 10s

    const heartbeat = setInterval(function () {
        if (Date.now() - lastEventAt > heartbeatMs * 2) {
            es.close();
            clearInterval(heartbeat);
            clearTimeout(watchdog);
            $message.text("Sem resposta do servidor. Conexão finalizada.");
            setTimeout(function () {
                modal.hide();
            }, 1200);
        }
    }, heartbeatMs);

    const watchdog = setTimeout(function () {
        es.close();
        clearInterval(heartbeat);
        $message.text("Tempo excedido na exportação. Tente novamente.");
        setTimeout(function () {
            modal.hide();
        }, 1200);
    }, maxMs);

    es.onopen = function () {
        lastEventAt = Date.now();
    };

    es.addEventListener("progress", function (ev) {
        try {
            lastEventAt = Date.now();
            const data = JSON.parse(ev.data);
            const current = data.current || 0;
            const total = data.total || 0;
            const percent = total > 0 ? Math.round((current / total) * 100) : 0;
            $message.text(`Criando PDF ${current} de ${total}`);
            $bar.css("width", percent + "%").text(percent + "%");
        } catch (err) {
            // noop
        }
    });

    es.addEventListener("status", function (ev) {
        try {
            lastEventAt = Date.now();
            const d = JSON.parse(ev.data);
            const c = d.current || 0;
            const t = d.total || 0;
            const osId = d.os_id || "";
            $("#exportProgressMessage").text(
                `Iniciando PDF da OS ${osId} (${c}/${t})`
            );
        } catch (err) {
            // noop
        }
    });

    es.addEventListener("completed", function (ev) {
        try {
            lastEventAt = Date.now();
            const data = JSON.parse(ev.data);
            const downloadUrl = data.download_url;
            $message.text("Empacotando ZIP... Concluído");
            $bar.css("width", "100%").text("100%");
            es.close();
            clearInterval(heartbeat);
            clearTimeout(watchdog);
            // Inicia download automaticamente
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                modal.hide();
                document.body.removeChild(a);
            }, 1200);
        } catch (err) {
            es.close();
            clearInterval(heartbeat);
            clearTimeout(watchdog);
            $message.text("Erro ao finalizar exportação.");
        }
    });

    es.addEventListener("error", function (ev) {
        lastEventAt = Date.now();
        es.close();
        clearInterval(heartbeat);
        clearTimeout(watchdog);
        try {
            if (ev && ev.data) {
                const d = JSON.parse(ev.data);
                const osId = d.os_id ? ` da OS ${d.os_id}` : "";
                const msg = d.message || "Erro durante exportação";
                const err = d.error ? `: ${d.error}` : "";
                $message.text(`${msg}${osId}${err}.`);
            } else {
                $message.text("Erro durante exportação. Tente novamente.");
            }
        } catch (_) {
            $message.text("Erro durante exportação. Tente novamente.");
        }
    });
});
